import { Home, ChevronRight, ChevronRightGold, Add } from "@dippi/icons";
import { getAuthenticatedPages, getRoutes } from "@/utils/helpers";
import { Box, Breadcrumbs, Button } from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useBreadcrumbs } from "./hooks";
import { Styled } from "./styles";
import { Params } from "@/types/utils";
import { useFormStatus } from "@dippi/forms";

const HeaderBottom: React.FC = () => {
    const { bid, pid } = useParams<Params>();
    const navigate = useNavigate();

    const pages = getAuthenticatedPages();
    const { breadcrumbs, onNavLinkClickHandler } = useBreadcrumbs(pages);
    const { id: formId, isDirty, setModal } = useFormStatus();

    const submitText =
        pages.brandSettings && !bid
            ? "Create"
            : pages.settings || pages.profile
              ? "Save"
              : pages.productSettings && !pid
                ? "Publish"
                : "Save";

    const routes = getRoutes();

    const onCancel = () => {
        if (pages.productSettings) {
            isDirty ? setModal(true, routes.products()) : navigate(routes.products());
        }

        if (pages.brandSettings || pages.settings || pages.profile) {
            isDirty ? setModal(true, routes.brands()) : navigate(routes.brands());
        }
        
    };

    return (
        <Styled.Container>
            <Breadcrumbs separator={false}>
                {breadcrumbs.map(({ text, route }, index) => {
                    const isFirst = index === 0;

                    return (
                        <Styled.NavLink
                            data-testid={`breadcrumbs-link-${index}`}
                            key={index}
                            to={route}
                            end
                            onClick={e => onNavLinkClickHandler(e, route)}
                        >
                            {({ isActive }) => (
                                <>
                                    {isFirst && (
                                        <Styled.Button data-testid="breadcrumbs-home-button">
                                            <Home />
                                        </Styled.Button>
                                    )}
                                    {isActive && !isFirst ? (
                                        <ChevronRightGold />
                                    ) : !isActive && !isFirst ? (
                                        <ChevronRight />
                                    ) : null}
                                    {text}
                                </>
                            )}
                        </Styled.NavLink>
                    );
                })}
            </Breadcrumbs>

            {pages.brands ? (
                <Button
                    data-testid="new-brand-button"
                    type="button"
                    onClick={() => navigate(routes.brandSettings())}
                    startIcon={<Add />}
                    sx={{ padding: "8px 16px 8px 8px" }}
                >
                    New brand
                </Button>
            ) : pages.brandSettings || pages.productSettings || pages.settings || pages.profile ? (
                <Box sx={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <Button
                        data-testid="form-cancel-button"
                        type="button"
                        variant="outlined"
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        data-testid="form-submit-button"
                        type="submit"
                        disabled={!isDirty}
                        form={formId}
                        sx={{ width: { sm: "120px", xs: "10px" } }}
                    >
                        {submitText}
                    </Button>
                </Box>
            ) : null}
        </Styled.Container>
    );
};

export default HeaderBottom;
